(ns minorodata.components.pipeline-editor.sql-generator
  "Pipeline-Editor container for the SQL generator (a.k.a. JSON flattening) modal.
   Route-gated by `:sql-generator true` in the URL query; the `:sql-generator-group-id`
   and `:sql-generator-transform-name` query params identify the sandbox transform
   to be created. Mounts the shared view from `transformations.sql-generator.view`
   and exposes a single header action: create the sandbox transform with the
   generated SQL as its command, then close. No persistence happens until the
   user clicks Create — closing the modal without submitting discards the work."
  (:require
   [clojure.string :as c.string]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.transformations.sql-generator.view :as view]
   [re-posh.core :as re-posh]
   [ui.button]
   [ui.dialog :refer [dialog-content dialog-root]]))


(defn close-modal []
  (dispatch [:app.events/navigate-query {:sql-generator                nil
                                         :sql-generator-group-id       nil
                                         :sql-generator-transform-name nil
                                         :sql-generator-lock-table     nil
                                         :table-name                   nil}])
  (js/setTimeout #(dispatch [:json-flattening/delete])
                 100))


(defn- create-and-insert! [{:keys [group-id transform-name sql open-as-new-tab?]}]
  (dispatch [(if open-as-new-tab?
               :pipeline-editor.events/create-and-open-transform
               :pipeline-editor.events/create-and-select-transform)
             {:group-id  group-id
              :transform {:name    transform-name
                          :command sql}}])
  (close-modal))


(defn modal* [{:keys [group-id transform-name lock-table?]}]
  (let [code             @(re-posh/subscribe [:json-flattening/prop :json-flattening/code])
        preview-loading? @(re-posh/subscribe [:mold-http/loading? :json-flattening.api/fetch-sql])
        creating?        @(re-posh/subscribe [:mold-http/loading? :sandbox.api/create-sandbox-transform])
        active-tab       @(re-posh/subscribe [:pipeline-editor.subs/active-tab])
        empty-tab?       (= "empty" (:type active-tab))
        can-insert?      (and group-id
                              (not (c.string/blank? transform-name))
                              (not preview-loading?)
                              (not creating?)
                              (not (c.string/blank? code)))]
    [dialog-root {:open  true
                  :modal false}
     [dialog-content {:size    :full
                      :modal   false
                      :x-close false
                      :class   "p-0"}
      [:f> view/view
       {:lock-table? lock-table?
        :on-close    close-modal
        :header-actions
        [ui.button/button
         {:on-click #(create-and-insert! {:group-id         group-id
                                          :transform-name   transform-name
                                          :sql              code
                                          :open-as-new-tab? empty-tab?})
          :disabled (not can-insert?)
          :loading  creating?
          :data-cy  "pe-sql-generator-create-btn"}
         "Create transform"]}]]]))


(defn modal []
  (let [route          @(re-posh/subscribe [:app-route/pull])
        query          (get route :app-route/query)
        opened?        (:sql-generator query)
        group-id       (:sql-generator-group-id query)
        transform-name (:sql-generator-transform-name query)
        lock-table?    (boolean (:sql-generator-lock-table query))]
    (when opened?
      [:f> modal* {:group-id       group-id
                   :transform-name transform-name
                   :lock-table?    lock-table?}])))
